function pubsListRoutes($stateProvider) {
  $stateProvider
    .state('publications.list', {
      url: '?websites&set',
      params: {
        websites: {
          dynamic: true,
          array: true
        },
        set: {
          dynamic: true
        }
      },
      component: 'publicationsListContainer',
      data: {
        pageTitle: {
          de: 'Printkanäle',
          en: 'Publications',
          es: 'Publicaciones',
          fr: 'Publications'
        }
      },
      resolve: {
        loadModule: ['$ocLazyLoad', $ocLazyLoad => import('./publicationsSearch')
          .then((pubSearchModule) => {
            $ocLazyLoad.load({ name: 'websked.publications.search' });
            return pubSearchModule;
          })],
        publicationsList: [
          'Publication',
          '$transition$',
          (Publication, $transition$) => Publication.getPublicationsList({
            size: 20,
            website: $transition$.params().websites,
            set: $transition$.params().set
          })
            .then(publicationsList => publicationsList)
        ],
        publicationsTotalCount: [
          'Publication',
          Publication => Publication.getNumberOfPublications()
            .then(publicationsTotalCount => publicationsTotalCount)
        ],
        sites: [
          'siteService',
          siteService => siteService.getWebsites()
            .then(sites => sites, () => [])
        ],
        publicationSets: [
          'Publication',
          Publication => Publication.getSets()
        ],
        $state: [
          '$state',
          $state => $state
        ],
        $transitions: [
          '$transitions',
          $transitions => $transitions
        ]
      }
    });
}

export default function (ngModule) {
  ngModule.config([
    '$stateProvider',
    pubsListRoutes
  ]);
}
